<template>
    <div class="canvas-activities" v-if="is_ready">
        <canvas-layout :stage="stage"
                       page="activities">

            <canvas-stage-browser :active-stage="stage"
                                  @browse="changeStage"/>

            <canvas-onboard-activities :stage="stage"/>
        </canvas-layout>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CanvasLayout from "@/Layouts/Canvas2/CanvasLayout";
import CanvasOnboardActivities from "@/Components/Canvas2/CanvasOnboardActivities";
import CanvasStageBrowser from "@/Components/Canvas2/CanvasStageBrowser";
import Button from "@/Jetstream/Button";

export default {
    name: "CanvasActivities",
    components: {Button, CanvasStageBrowser, CanvasOnboardActivities, CanvasLayout},

    props: {
        canvas: {
            type: Object,
            default: () => null,
        },

        stage: {
            type: String,
            default: () => null,
        },

    },


    data(){
        return {
            is_ready: false,
            value: 0,
        }
    },

    computed: {

        ...mapGetters('canvas2', ['_$$canvas', '_$$path', 'project', 'team']),

    },


    methods: {

        ...mapActions('canvas2', ['initCanvas', 'pushCanvasFragments']),

        changeStage(stage){
            this.$inertia.visit(
                this.route('student.canvas2.activities', {
                    uuid: this.canvas.uuid,
                    stage: stage.stage.slug,
                    ...this.global_url_params
                })
            );
        },

        save(){

            if( this.is_valid ){

            }

            this.pushCanvasFragments({
                stage: this.stage,
                fragments: {
                    value: ++ this.value,
                    string_fragment: Math.random(),
                    object_fragment: {
                        can: 'store ' + Math.random(),
                        objects: 'in fragments ' + Math.random(),
                        should: 'manage them automagically ' + Math.random(),
                    }
                }
            });
        }

    },


    async mounted() {
        await this.initCanvas( this.canvas );
        this.is_ready = true;
    }


}
</script>

<style lang="scss" scoped>

</style>
